/**
 * Logger Type Definitions for Support App
 */

// Log levels for general logging
export type LogLevel = 'debug' | 'info' | 'warn' | 'error' | 'off';

// Function call status
export type FnStatus = 'CALLING' | 'SUCCESS' | 'ERROR';

// Level display configuration
export interface LevelConfig {
  emoji: string;
  label: string;
  color: string;
}

// Level configuration
export const LEVEL_CONFIG: Record<Exclude<LogLevel, 'off'>, LevelConfig> = {
  debug: { emoji: '🐛', label: 'DEBUG', color: '#6B7280' },
  info: { emoji: 'ℹ️', label: 'INFO', color: '#3B82F6' },
  warn: { emoji: '⚠️', label: 'WARN', color: '#F59E0B' },
  error: { emoji: '❌', label: 'ERROR', color: '#EF4444' },
};

// Level hierarchy for filtering
export const LEVEL_HIERARCHY: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  off: 4,
};

// LocalStorage key
export const LOG_STORAGE_KEY = 'support_log_settings';
